// assets/swiper-loader.js
(function() {
  window.SwiperLoader = window.SwiperLoader || {
    _queue: [],
    _ready: false,

    /**
     * Runs callback as soon as Swiper is available.
     * Use for above-the-fold carousels that must init immediately.
     */
    onReady: function(callback) {
      if (this._ready || typeof Swiper !== 'undefined') {
        this._ready = true;
        callback(window.Swiper);
        return;
      }
      this._queue.push(callback);
      this._poll();
    },

    /**
     * Lazy init — waits until element is near the viewport, then inits.
     * Falls back to onReady if IntersectionObserver unavailable.
     *
     * @param {HTMLElement} element  - the .swiper root element
     * @param {Function}   initFn   - receives window.Swiper
     * @param {Object}     [opts]
     * @param {string}     [opts.rootMargin='400px 0px']
     */
    lazyInit: function(element, initFn, opts) {
      if (!element || typeof initFn !== 'function') return;

      // No IO support → immediate init
      if (typeof IntersectionObserver === 'undefined') {
        this.onReady(initFn);
        return;
      }

      opts = opts || {};
      var rootMargin = opts.rootMargin || '400px 0px';
      var loader = this;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            loader.onReady(initFn);
          }
        });
      }, { rootMargin: rootMargin });

      observer.observe(element);
    },

    _poll: function() {
      if (this._polling) return;
      this._polling = true;

      var self = this;
      var interval = setInterval(function() {
        if (typeof Swiper !== 'undefined') {
          clearInterval(interval);
          self._ready = true;
          self._polling = false;
          var callbacks = self._queue.slice();
          self._queue.length = 0;
          callbacks.forEach(function(cb) { cb(window.Swiper); });
        }
      }, 50);

      setTimeout(function() {
        clearInterval(interval);
        if (!self._ready) {
          console.error('[SwiperLoader] Swiper failed to load after 10s');
        }
      }, 10000);
    }
  };
})();